"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Button = _interopRequireDefault(require("../../Button"));

var _ = require("..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var isValidValue = function isValidValue(value) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return typeof value !== 'undefined' && values.map(function (v) {
    return v.value.toString();
  }).includes(value.toString());
};

var ValueSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(ValueSelector, _React$Component);

  var _super = _createSuper(ValueSelector);

  function ValueSelector() {
    var _this;

    _classCallCheck(this, ValueSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      showCustom: !isValidValue(_this.props.selected, _this.props.values)
    };

    _this.showCustomField = function () {
      _this.setState({
        showCustom: true
      });
    };

    _this.hideCustomField = function () {
      _this.setState({
        showCustom: false
      });
    };

    _this.toggleCustomField = function () {
      _this.setState({
        showCustom: !_this.state.showCustom
      });
    };

    return _this;
  }

  _createClass(ValueSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? function () {} : _this$props$onChange,
          _this$props$onCustomB = _this$props.onCustomBlur,
          onCustomBlur = _this$props$onCustomB === void 0 ? function () {} : _this$props$onCustomB,
          _this$props$onCustomC = _this$props.onCustomChange,
          onCustomChange = _this$props$onCustomC === void 0 ? function () {} : _this$props$onCustomC,
          _this$props$values = _this$props.values,
          values = _this$props$values === void 0 ? [] : _this$props$values,
          _this$props$selected = _this$props.selected,
          selected = _this$props$selected === void 0 ? '' : _this$props$selected,
          className = _this$props.className,
          allowCustom = _this$props.allowCustom,
          customFieldLabel = _this$props.customFieldLabel,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 'regular' : _this$props$size,
          readOnly = _this$props.readOnly,
          labelRenderer = _this$props.labelRenderer,
          onCustomClose = _this$props.onCustomClose,
          rounded = _this$props.rounded,
          showCustom = this.state.showCustom;
      return /*#__PURE__*/_react.default.createElement(_.Field, _extends({}, this.props, {
        className: (0, _classnames.default)('frikin-value-selector', className, {
          'frikin-value-selector-small': size === 'small'
        })
      }), function () {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "frikin-value-selector-options buttons has-addons"
        }, !showCustom && values.map(function (v, i) {
          return /*#__PURE__*/_react.default.createElement(_Button.default, {
            rounded: rounded,
            disabled: v.disabled,
            title: v.title,
            className: (0, _classnames.default)({
              'is-success is-selected': !showCustom && v.value.toString() === selected.toString()
            }),
            key: i,
            size: size,
            onClick: function onClick() {
              _this2.hideCustomField();

              !readOnly && onChange(v);
            }
          }, labelRenderer(v));
        }), showCustom && !readOnly && /*#__PURE__*/_react.default.createElement(_.SimpleTextField, {
          className: "custom-field",
          help: customFieldLabel,
          type: "text",
          value: selected,
          size: size,
          onChange: function onChange(e) {
            return onCustomChange(e.target.value);
          },
          onBlur: function onBlur(e) {
            return onCustomBlur(e.target.value);
          },
          onKeyPress: function onKeyPress(e) {
            return e.charCode == 13 && onCustomBlur(e.target.value);
          }
        }), (allowCustom || showCustom) && !readOnly && /*#__PURE__*/_react.default.createElement(_Button.default, {
          icon: showCustom ? 'times-circle' : 'plus-circle',
          size: size,
          className: (0, _classnames.default)('frikin-value-selector-custom-button'),
          onClick: function onClick() {
            showCustom && onCustomClose();

            _this2.toggleCustomField();
          }
        })));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps() {
      var newProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var oldState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return {
        showCustom: isValidValue(newProps.select, newProps.values) || (0, _get.default)(oldState, 'showCustom')
      };
    }
  }]);

  return ValueSelector;
}(_react.default.Component);

exports.default = ValueSelector;
ValueSelector.propTypes = {
  onChange: _propTypes.default.func,
  values: _propTypes.default.array,
  selected: _propTypes.default.any,
  className: _propTypes.default.string,
  allowCustom: _propTypes.default.bool,
  customFieldLabel: _propTypes.default.string,
  label: _propTypes.default.any,
  size: _propTypes.default.string,
  onCustomClose: _propTypes.default.func,
  labelRenderer: _propTypes.default.func,
  rounded: _propTypes.default.bool
};
ValueSelector.defaultProps = {
  values: [],
  onCustomClose: function onCustomClose() {},
  labelRenderer: function labelRenderer(v) {
    return v.label || v.value;
  }
};